// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"HeaderC_headerBox__1a4dv","innerContainer":"HeaderC_innerContainer__hiC1t","logo":"HeaderC_logo__1mDTC"};